import { render, staticRenderFns } from "./addfunds_enteredach.vue?vue&type=template&id=2899a68c&"
import script from "./addfunds_enteredach.vue?vue&type=script&lang=js&"
export * from "./addfunds_enteredach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports